<template>
  <SmartCard
    tag="button"
    class="link-card-wrapper rounded mb-3 px-3 py-2 flex align-center
    justify-between cursor-pointer w-full"
    @click.native="click">
    <div class="flex align-center">
      <div class="mr-3">
        <SmartIcon
          :name="icon"
          :size="10"
          type="big"
          class="font-opacity-sm"
        />
      </div>
      <div class="label-wrapper text-left">
        <div class="title-wrapper mb-1">{{title}}</div>
        <div class="subtitle-wrapper text-opacity-md">{{subtitle}}</div>
      </div>
    </div>
    <div>
      <SmartIcon
        :size="2"
        type="small"
        name="arrow_right"
      />
    </div>
  </SmartCard>
</template>

<script>
export default {
  name: 'SmartLinkCard',
  components: {
    SmartIcon: () => import('../SmartIcon'),
    SmartCard: () => import('../SmartCard')
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      required: true
    },
    value: {
      required: true
    }
  },
  methods: {
    click() {
      this.$emit('click', this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
  .link-card-wrapper {
    border-style: solid;
    border-width: $border-width-large;
    border-color: rgba($color-ui-black,$opacity-low-max);
    user-select: none;
    transition-property: border-color, transform, box-shadow;
    transition-duration: $transition-sm-fast;
    transition-timing-function: $transition-easing-default;
    .smart-icon {
      transition-property: opacity, color;
      transition-duration: $transition-sm-medium;
      transition-timing-function: $transition-easing-default;
    }
    .label-wrapper {
      font-family: $font-family-01;
      .title-wrapper {
        font-size: $font-size-h2;
        font-weight: $font-weight-bold;
        overflow: hidden;
        text-transform: uppercase;
      }
      .subtitle-wrapper {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &:hover, &:active, &:focus {
      border-color: $color-brand-primary;
      .smart-icon {
        opacity: 1;
        color: $color-brand-primary;
      }
    }
    &:active, &:focus {
      transform: scale(1.01);
      box-shadow: $box-shadow-hg;
    }
    &:focus {
      outline: none;
    }
  }

  @include device-size(sm) {
    .subtitle-wrapper {
      width: 21ch;
    }
  }
</style>
